export { StickyCta, type StickyCtaProps } from './StickyCta';
